import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as clients from '../../clients'

export const RESOURCE = {
  payload: {
    description: 'Clients that Attain Partners serves',
    dimension: clients.RESOURCE.payload,
    level: 0,
    name: 'Client',
    partialId: PartialId.Standard.create('client'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
